import type { PublicationModel } from './publication'

export type PublicationEditionModel = {
  artwork_deadline: string,
  booking_deadline: string,
  cache_key: number,
  dates?: any,
  deadlines?: {
    artwork?: string,
    booking?: string,
    editorial?: string,
    next_up?: { type: 'string', date: string },
    ofi?: string,
  },
  editorial_deadline?: string,
  id: number,
  inspection_deadline?: string,
  order_item_count?: number,
  publication_date: string,
  publication_id: number,
  special_deadline?: boolean,
  title: string,
}

export type AvailableLiftover = {
  edition: PublicationEditionModel,
  provider_price_list_item_id: number,
  provider_price_list_product_unlock_id: number,
  publication: PublicationModel,
  publication_edition_id: number,
  publication_id: number,
  unlock_price_list_id: number,
  unlock_product_id: number,
}

export type PublicationEditionRequestOptions = {
  include_publication_edition_deadlines?: boolean,
  include_publication_edition_publication?: boolean,
  include_publication_logo?: boolean,
  include_unused_editions?: boolean,
}

const state = {
  artwork_deadline: '',
  booking_deadline: '',
  editorial_deadline: '',
  inspection_deadline: '',
  id: null,
  publication_date: '',
  publication_id: undefined,
  special_deadline: false,
  title: '',
}

export const requiredFields = [
  { key: 'artwork_deadline' },
  { key: 'booking_deadline' },
  { key: 'publication_date' },
  { key: 'publication_id' },
  { key: 'title' },
]

export default state
